import { SiteHeader } from '../components/SiteHeader';
import { useDocumentMeta } from '../lib/useDocumentMeta';

export function TestingArea() {
  useDocumentMeta({ title: 'Testing Area | Tyler Wrenn', robots: 'noindex, nofollow' });

  return (
    <main>
      <SiteHeader />

      <section className="bg-dark py-5">
        <div className="container">
          <h1 className="display-4">Testing Area</h1>
          <p className="lead">This is an area where I test features.</p>
        </div>
      </section>

      <section className="bg-dark text-center py-5">
        <div className="container">
          <hr className="border-white" />
          <footer>
            <p className="small">Designed by Tyler Wrenn</p>
          </footer>
        </div>
      </section>
    </main>
  );
}
